import Vue from 'vue'
import ApiConfig from './api_config'

export default {
  async get(farmId) {
    try {
      const result = await Vue.prototype.$http.get(`${ApiConfig.BASE_URL}/device/farm/${farmId}`)
      return result.data.data
    } catch (error) {
      console.error(error)
      throw error
    }
  },

  async getAll() {
    try {
      const result = await Vue.prototype.$http.get(`${ApiConfig.BASE_URL}/device`)
      return result.data.data
    } catch (error) {
      console.error(error)
      throw error
    }
  },

  async getById(id) {
    try {
      const result = await Vue.prototype.$http.get(`${ApiConfig.BASE_URL}/device/${id}`)
      return result.data.data
    } catch (error) {
      console.error(error)
      throw error
    }
  },

  async getByUser(id) {
    try {
      const result = await Vue.prototype.$http.get(`${ApiConfig.BASE_URL}/device/user/${id}`)
      return result.data.data
    } catch (error) {
      console.error(error)
      throw error
    }
  },

  async getLog(id) {
    try {
      const result = await Vue.prototype.$http.get(`${ApiConfig.BASE_URL}/device/log/${id}`)
      return result.data.data
    } catch (error) {
      console.error(error)
      throw error
    }
  },

  async getLogDay(id, day) {
    try {
      const result = await Vue.prototype.$http.get(`${ApiConfig.BASE_URL}/device/log/day/${id}/${day}`)
      return result.data.data
    } catch (error) {
      console.error(error)
      throw error
    }
  },

  async getLogHour(id, hour) {
    try {
      const result = await Vue.prototype.$http.get(`${ApiConfig.BASE_URL}/device/log/hour/${id}/${hour}`)
      return result.data.data
    } catch (error) {
      console.error(error)
      throw error
    }
  },

  async getLogWeek(id) {
    try {
      const result = await Vue.prototype.$http.get(`${ApiConfig.BASE_URL}/device/log/week/${id}`)
      return result.data.data
    } catch (error) {
      console.error(error)
      throw error
    }
  },

  async getLogDate(e) {
    try {
      const result = await Vue.prototype.$http.post(`${ApiConfig.BASE_URL}/device/log/date`, e)
      return result.data.data
    } catch (error) {
      console.error(error)
      throw error
    }
  },

  async delete(e) {
    try {
      const result = await Vue.prototype.$http.delete(`${ApiConfig.BASE_URL}/device`, { data: { _id: e._id } })
      return result.data
    } catch (error) {
      console.error(error)
      throw error
    }
  },
  async insert(e) {
    try {
      const result = await Vue.prototype.$http.post(`${ApiConfig.BASE_URL}/device`, e)
      return result.data
    } catch (error) {
      console.log(error.response)
      throw error.response
    }
  },
  async update(e) {
    try {
      const result = await Vue.prototype.$http.put(`${ApiConfig.BASE_URL}/device`, e)
      return result.data
    } catch (error) {
      console.error(error)
      throw error
    }
  },
  async updateDataSource(e) {
    try {
      const result = await Vue.prototype.$http.put(`${ApiConfig.BASE_URL}/device/data-source`, e)
      return result.data
    } catch (error) {
      console.error(error)
      throw error
    }
  },
  async update_status(e) {
    try {
      const result = await Vue.prototype.$http.put(`${ApiConfig.BASE_URL}/device/status`, e)
      return result.data
    } catch (error) {
      console.error(error)
      throw error
    }
  },
  async update_card(e) {
    try {
      const result = await Vue.prototype.$http.put(`${ApiConfig.BASE_URL}/device/card`, e)
      return result.data
    } catch (error) {
      console.error(error)
      throw error
    }
  },
  async update_mixer(e) {
    try {
      const result = await Vue.prototype.$http.put(`${ApiConfig.BASE_URL}/device/mixer`, e)
      return result.data
    } catch (error) {
      console.error(error)
      throw error
    }
  },
  async insert_sensor_notify(e) {
    try {
      const result = await Vue.prototype.$http.post(`${ApiConfig.BASE_URL}/device/sensor-notify`, e)
      return result.data
    } catch (error) {
      console.log(error.response)
      throw error.response.data
    }
  },
  async getEventLog(id) {
    try {
      const result = await Vue.prototype.$http.get(`${ApiConfig.BASE_URL}/event-log/device/${id}`)
      return result.data.data
    } catch (error) {
      console.error(error)
      throw error
    }
  },
  async deleteEventLogByDevice(e) {
    try {
      const result = await Vue.prototype.$http.delete(`${ApiConfig.BASE_URL}/event-log/all`, { data: e })
      return result.data
    } catch (error) {
      console.error(error)
      throw error
    }
  },
  async deleteDataLogByDevice(e) {
    try {
      const result = await Vue.prototype.$http.delete(`${ApiConfig.BASE_URL}/device/log/clear`, { data: e })
      return result.data
    } catch (error) {
      console.error(error)
      throw error
    }
  },
}
